module.exports = __webpack_public_path__ + "img/UK.cba89324.svg";